module.exports = __webpack_public_path__ + "img/new_photography.688bdda0.svg";